import { styled } from '@mui/material';

export const Sounds = styled('div')`
  position: absolute;
  z-index: 999;
  bottom: 35px;
  left: 50%;
  transform: translateX(-50%);
  width: 300px;
  height: 60px;
  opacity: 1;
  background-color: #5e5646;
  border-radius: 5px;
  padding: 0px 10px;

  & > .container-controls {
    position: absolute;
    display: flex;
    right: 0;
    top: -17px;
    background: #5e5646;
    padding: 3px 7px;
    border-radius: 4px;
    opacity: 1;

    .fas {
      font-size: 15px;
      color: white;
      padding: 2px 6px;

      &:hover {
        color: rgb(143, 139, 139);
        cursor: pointer;
      }
    }
  }

  .sound-range {
    // TODO: Refactor inside mixin
    input[type='range'] {
      width: 100%;
      background-color: transparent;
      -webkit-appearance: none;
      padding: 0;
      margin: 0;
    }

    input[type='range']:focus {
      outline: none;
    }

    input[type='range']::-webkit-slider-runnable-track {
      background: #ffffff;
      width: 100%;
      height: 5px;
      cursor: pointer;
      opacity: 1;
    }

    input[type='range']::-webkit-slider-thumb {
      margin-top: -7px;
      width: 18px;
      height: 18px;
      background: #ffffff;
      border-radius: 50%;
      cursor: pointer;
      -webkit-appearance: none;
    }

    input[type='range']:focus::-webkit-slider-runnable-track {
      background: #ffffff;
    }

    input[type='range']::-moz-range-track {
      background: #ffffff;
      width: 100%;
      height: 5px;
      cursor: pointer;
    }

    input[type='range']::-moz-range-thumb {
      margin-top: -7px;
      width: 18px;
      height: 18px;
      background: #ffffff;
      border-radius: 50%;
      cursor: pointer;
      -webkit-appearance: none;
    }

    input[type='range']::-ms-track {
      background: transparent;
      border-color: transparent;
      color: transparent;
      width: 100%;
      height: 5px;
      cursor: pointer;
    }

    input[type='range']::-ms-fill-lower {
      background: #ffffff;
    }

    input[type='range']::-ms-fill-upper {
      background: #ffffff;
    }

    input[type='range']::-ms-thumb {
      width: 18px;
      height: 18px;
      background: #ffffff;
      border-radius: 50%;
      cursor: pointer;
      margin-top: 0;
    }

    input[type='range']:focus::-ms-fill-lower {
      background: #ffffff;
    }

    input[type='range']:focus::-ms-fill-upper {
      background: #ffffff;
    }

    input[type='range'] {
      height: 11px;
    }

    input[type='range']::-webkit-slider-thumb {
      margin-top: -4px;
      width: 12px;
      height: 12px;
    }
  }

  .sound-controls {
    display: flex;
    flex-direction: row;
    color: #fff;
    justify-content: space-between;

    .left-side {
      display: flex;
      flex-direction: row;
      height: 15px;
      align-items: center;
      margin-top: 10px;

      > div {
        margin-right: 10px;

        &:hover {
          opacity: 0.5;
        }
      }

      .played {
        margin-left: 15px;
      }

      .caption {
        margin-left: 15px;
      }

      .time {
        margin-left: 15px;
      }

      .volume {
        margin-left: 20px;
        display: flex;
        justify-content: center;
        align-items: center;

        // TODO: Refactor inside mixin
        input[type='range'] {
          width: 100%;
          background-color: transparent;
          -webkit-appearance: none;
          padding: 0;
          margin: 0;
        }

        input[type='range']:focus {
          outline: none;
        }

        input[type='range']::-webkit-slider-runnable-track {
          background: #ffffff;
          width: 100%;
          height: 5px;
          cursor: pointer;
          opacity: 1;
        }

        input[type='range']::-webkit-slider-thumb {
          margin-top: -7px;
          width: 18px;
          height: 18px;
          background: #ffffff;
          border-radius: 50%;
          cursor: pointer;
          -webkit-appearance: none;
        }

        input[type='range']:focus::-webkit-slider-runnable-track {
          background: #ffffff;
        }

        input[type='range']::-moz-range-track {
          background: #ffffff;
          width: 100%;
          height: 5px;
          cursor: pointer;
        }

        input[type='range']::-moz-range-thumb {
          margin-top: -7px;
          width: 18px;
          height: 18px;
          background: #ffffff;
          border-radius: 50%;
          cursor: pointer;
          -webkit-appearance: none;
        }

        input[type='range']::-ms-track {
          background: transparent;
          border-color: transparent;
          color: transparent;
          width: 100%;
          height: 5px;
          cursor: pointer;
        }

        input[type='range']::-ms-fill-lower {
          background: #ffffff;
        }

        input[type='range']::-ms-fill-upper {
          background: #ffffff;
        }

        input[type='range']::-ms-thumb {
          width: 18px;
          height: 18px;
          background: #ffffff;
          border-radius: 50%;
          cursor: pointer;
          margin-top: 0;
        }

        input[type='range']:focus::-ms-fill-lower {
          background: #ffffff;
        }

        input[type='range']:focus::-ms-fill-upper {
          background: #ffffff;
        }

        input[type='range'] {
          height: 11px;
        }

        input[type='range']::-webkit-slider-thumb {
          margin-top: -4px;
          width: 12px;
          height: 12px;
        }
      }
    }
  }
`;
